module.exports = __webpack_public_path__ + "img/shipinghao_20250429161633.7ba92898.jpg";